<template>
    <div class="setting-box">
        <div v-for="(item, index) in categoryList&&categoryList" :class="{ 'child-top': index > 0 }" class="setting-item"
            :key="index">
            <div style="display: flex; align-items: center;" v-if="item.parentId==-1">
                <span>{{ `第${numberToChinese(index + 1)}章` }}</span>
                <div style="margin-left: 1rem;width: 49rem;flex: 1;" class="overflow">{{ item.name }}</div>
                <el-tooltip class="item" effect="dark" content="暂无权限" :disabled="item.authStatus" placement="top-start">
                    <div class="btn-box" v-if="item.resourceId&&(!item.children||item.children.length==0)" :class="[{'disabled-btn':!item.authStatus},{'disabled-label':!item.authStatus}]" @click="toStudy(item)">进入学习</div>
                </el-tooltip>
            </div>
            <div v-else-if="!item.children||item.children.length==0" class="el-item" :key="index">
                <i class="iconfont icon-bofang"></i>
                <div>{{ `第${numberToChinese(index + 1)}节` }}</div>
                <div class="overflow" style="flex: 1;">{{ item.name }}</div>
                <el-tooltip class="item" effect="dark" content="暂无权限" :disabled="item.authStatus" placement="top-start">
                    <div class="btn-box" v-if="item.resourceId" :class="[{'disabled-btn':!item.authStatus},{'disabled-label':!item.authStatus}]" @click="toStudy(item)">进入学习</div>
                </el-tooltip>
            </div>
            <div v-else style="display: flex">
                <div style="width: 5rem;" class="overflow">{{ analysisIndex(item,index) }}</div>
                <div style="margin-left: 1rem;flex: 1;">{{ item.name }}</div>
            </div>
            <category :categoryList="item.children" :id="id" :lastIndex="sortIndex(index)"></category>
        </div>
    </div>
</template>

<script>
import { numberToChinese } from '@/utils/utils';
import { isToLogin } from '@/utils/utils';
import { StudyCourse } from '@/api/study';
export default {
    name:'Category',
    props:['categoryList','lastIndex','id'],
    methods:{
        numberToChinese,
        /**进入学习 */
        toStudy(ele){
            if(!ele.authStatus)return;
            if(!isToLogin())return;
            let params={
                courseId:this.$route.query.id||this.id,
                openCourseId:this.$store.state.course.courseDetailData.detail.openCourseId
            }
            StudyCourse(params).then(res=>{
                if(res.code==200){
                    localStorage.setItem('course_study_back',this.$route.fullPath);
                    this.$router.push({
                            path:'/course/studyCourse',
                            query:{
                                id:this.$route.query.id||this.id,
                                openCourseId:this.$store.state.course.courseDetailData.detail.openCourseId,
                                courseLearningSource:'course_study'
                            }
                        });
                    localStorage.setItem('currentStudyItem',JSON.stringify(ele));
                }
            })
            },
        sortIndex(index){
                if(this.lastIndex){
                    return [...this.lastIndex,index+1];
                }
                return [index+1];
            },
        analysisIndex(item,index){
                if(item.parentId==-1){
                    return '章节'+(index+1)
                }else{
                    return this.sortIndex(index).join('.');
                }
            }
    },
    computed:{
            /**课程详情 */
            courseDetail(){
                return this.$store.state.course.courseDetailData;
            },
        }
}
</script>

<style lang="less" scoped>
.setting-box{
    .setting-item{
        color: #151C34;
        font-size: 16px;
        margin-top: 2rem;
        .el-item{
            padding-bottom: 2rem;
            border-bottom:1px solid #f1f1f1;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #334681;
            &> :nth-child(2){
                margin-right: 1.3rem;
            }
            &> :nth-child(3){
                width: 45rem;
                margin-right: 1.3rem;
            }
            .file-box{
                flex: 1;
            }
            .icon-bofang{
                color: #8590B3;
                margin-right: 1.3rem;
            }
            .e-item{
                color: #387DFF;
                font-size: 12px;
            }
        }
    }
}
.btn-box{
                height: 2.4rem;
                width: 7rem;
                background: #387dff;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
                font-size: 12px;
                margin-left: 1rem;
                cursor: pointer;
            }
</style>